import { Box, Button, Link, makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import OTPInput from 'otp-input-react';
import useToast from '../../../hooks/useToast';
import { useDispatch } from 'react-redux';
import { verifyOtpMail } from '../ForgetPwdStore/forgetPwdSlice';

const useStyles = makeStyles((theme) => ({
  greyText: {
    color: theme.palette.buzzGreyColor,
  },
  smallText: {
    ...theme.typography.body2,
  },
  verticalSpace: {
    margin: '50px 0',
  },
  button: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.buzzContainerColor,
  },
  otpInputs: {
    '& input': {
      background: theme.palette.buzzGreyBlue,
      border: '1px solid black',
      height: '55px !important',
      width: '40px !important',
    },
  },
}));

function OtpScreen({ email, setShowSetPwdScreen, setOtpValue }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [otp, setOtp] = useState();
  const { SuccessToast, ErrorToast } = useToast();

  const handleVerifyOtp = () => {
    dispatch(
      verifyOtpMail({
        email: email,
        otp: otp,
      })
    )
      .unwrap()
      .then((res) => {
        setShowSetPwdScreen(true);
        SuccessToast('Otp matched successfully!');
        setOtpValue(otp);
      })
      .catch((err) => {
        ErrorToast('OTP not matched!');
      });
  };

  return (
    <Box mt={-2}>
      <OTPInput
        value={otp}
        onChange={setOtp}
        autoFocus
        OTPLength={6}
        disabled={false}
        className={classes.otpInputs}
      />
      <Box mt={3}>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleVerifyOtp}>
          Continue
        </Button>
        <Box mt={2} />
        <Link href="/signin">
          <Button variant="outlined" color="primary" fullWidth>
            Return to Sign in
          </Button>
        </Link>
      </Box>
    </Box>
  );
}

export default OtpScreen;
